const l = {
  name: "UpliftProtect",
  dimensions: { width: 24, height: 24 },
  content: `
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="M21 2h-5V0h7v7h-2z" style="fill: currentColor;"/><path fill="#fff" d="M17 6h-5V4h7v7h-2z" style="fill: currentColor;"/><path fill="#fff" d="M19 11h2v3.29a7 7 0 0 1-3.873 6.264L12 23.118l-5.129-2.564A7.01 7.01 0 0 1 3 14.29V2h9v2H5v10.29a5.01 5.01 0 0 0 2.768 4.476L12 20.882l4.233-2.116A5 5 0 0 0 19 14.29z" style="fill: currentColor;"/></svg>
  `
};
export {
  l as UpliftProtect
};
